/**
 * The most units one cart line may hold. Client-safe, so the storefront's
 * steppers and the server's cookie schema read the same number: a client that
 * lets a line past it posts a cart the checkout's item schema rejects whole.
 */
export const MAX_LINE_QTY = 999;
